import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import {
  AssistantActions,
  Conversation,
  ConversationSearchModal,
  HistoryChats
} from 'features/ai-assistant/components';
import { useSearchModal } from 'features/ai-assistant/hooks';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { UIStatus } from 'UI/constants/status';

import { useAIAssistantDrawer } from './AIAssistantDrawer.hooks';
import { useDrawerStyles } from './AIAssistantDrawer.styled';

export const AIAssistantDrawer = ({ open, onClose }) => {
  const classes = useDrawerStyles();
  const { isSearchOpen, handleOpenSearch, handleCloseSearch } = useSearchModal();

  const {
    chats,
    currentSessionId,
    fetchMoreConversations,
    handleClickConversation,
    handleClickNewChat,
    handleDeleteConversation,
    handleMessageReplied,
    handlePinConversation,
    handleRenameConversation,
    hasMoreConversations,
    isLoadingMoreConversations,
    resetKey,
    uiStatus
  } = useAIAssistantDrawer();

  const handleSelectResult = ({ sessionId }) => {
    handleClickConversation(sessionId);
    handleCloseSearch();
  };

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick') return;
    onClose && onClose();
  };

  return (
    <FPDrawer
      CardHeaderProps={{
        title: strings.ai.generators.assistant.title,
        subheader: strings.ai.generators.assistant.subHeader
      }}
      FPDrawerProps={{
        open,
        classes: { paper: classes.drawerLarge },
        ModalProps: { disableEscapeKeyDown: true }
      }}
      onClose={handleClose}
      hasPaddingContent={false}
      hideFooter
    >
      <div className={classes.dualContainers}>
        <div className={classes.historyListContainer}>
          <AssistantActions onClickNewChat={handleClickNewChat} onClickSearch={handleOpenSearch} />
          <When condition={uiStatus === UIStatus.Loading || isLoadingMoreConversations}>
            <LinearProgress />
          </When>
          <When condition={uiStatus === UIStatus.Success || uiStatus === UIStatus.Empty}>
            <HistoryChats
              hasMoreConversations={hasMoreConversations}
              historyChats={chats}
              isLoadingMoreConversations={isLoadingMoreConversations}
              onClickConversation={handleClickConversation}
              onDeleteConversation={handleDeleteConversation}
              onFetchMore={fetchMoreConversations}
              onPinConversation={handlePinConversation}
              onRenameConversation={handleRenameConversation}
              selectedChatId={currentSessionId}
            />
          </When>
        </div>

        <div className={classes.conversationPanel}>
          <Alert className={classes.styledAlert} severity="warning">
            {strings.ai.generators.alert}
          </Alert>
          <Conversation
            key={resetKey}
            sessionId={currentSessionId}
            onMessageReplied={handleMessageReplied}
          />
        </div>
      </div>

      <ConversationSearchModal
        open={isSearchOpen}
        onClose={handleCloseSearch}
        onSelectResult={handleSelectResult}
      />
    </FPDrawer>
  );
};
